module.exports = __webpack_public_path__ + "static/media/ic_refresh_02.3bc68fe0.svg";